import { useInfiniteQuery } from 'react-query';
import { getMailHistory } from './MailHistory.service';
import { MailHistoryParamsInterface } from './MailHistory.types';
import notificationError from '@/utils/functions/notificationError';

export function useMailsHistory(params?: MailHistoryParamsInterface) {
  return useInfiniteQuery(
    ['mail-history', params],
    () => getMailHistory(params),
    {
      onError(error) {
        notificationError(error);
      },
    },
  );
}
